import logo from "../assets/img/logo.png";
import officialSong from "../assets/audio/officialSong.mpeg";
import { Modal } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import ContactForm from "./modal/contact";
import ElectionResultsModal from "./ElectionResultsModal";

const NOTIFICATIONS = [
  {
    id: 1,
    icon: "🗳️",
    title: "Intra-Party Election Results",
    body: "Technology Movement Pakistan (TMP) congratulates all newly elected office bearers on their successful election. We wish them every success in serving the party and the nation. Official assumption of responsibilities: 22.01.2026.",
    time: "22 Jan 2026",
    unread: true,
  },
];

function BellDropdown({ onOpenElection }) {
  const [open, setOpen]         = useState(false);
  const [read, setRead]         = useState(false);
  const ref                     = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleNotifClick = () => {
    setRead(true);
    setOpen(false);
    onOpenElection();
  };

  return (
    <div className="notif-wrap" ref={ref}>
      <button
        className="notif-bell"
        onClick={() => setOpen(o => !o)}
        aria-label="Notifications"
        title="Notifications"
      >
        <svg className="notif-bell__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        <span className="notif-bell__label">Notifications</span>
        {!read && <span className="notif-bell__dot" />}
      </button>

      {open && (
        <div className="notif-dropdown">
          <div className="notif-dropdown__header">
            <span className="notif-dropdown__title">Notifications</span>
            {!read && <span className="notif-dropdown__badge">1 new</span>}
          </div>

          {NOTIFICATIONS.map(n => (
            <button
              key={n.id}
              className={`notif-item ${!read && n.unread ? "notif-item--unread" : ""}`}
              onClick={handleNotifClick}
            >
              <div className="notif-item__icon">{n.icon}</div>
              <div className="notif-item__body">
                <div className="notif-item__title">{n.title}</div>
                <div className="notif-item__text">{n.body}</div>
                <div className="notif-item__meta">
                  <span className="notif-item__time">{n.time}</span>
                  <span className="notif-item__cta">View results →</span>
                </div>
              </div>
              {!read && n.unread && <span className="notif-item__dot" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function Header({ handleShow }) {
  const [showPlayer,   setShowPlayer]   = useState(false);
  const [showForm,     setShowForm]     = useState(false);
  const [showElection, setShowElection] = useState(false);

  useEffect(() => {
    if (showPlayer) document.getElementById("offSong")?.play();
  }, [showPlayer]);

  return (
    <div className="header">
      {/* Social top bar */}
      <div className="header-top bg-primary py-1">
        <div className="container">
          <ul className="header-links mb-0">
            <li className="nav-item">
              <a className="nav-link active" href="https://www.facebook.com/techmovementpak" target="_blank" rel="noreferrer">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link active" href="https://twitter.com/Techmovementpk" target="_blank" rel="noreferrer">
                <i className="fa-brands fa-twitter"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Main navbar */}
      <div className="container">
        <nav className="navbar navbar-expand-xl navbar-light">
          <div className="container-fluid">
            <a className="navbar-brand" href="/" style={{ width: "100px" }}>
              <img src={logo} className="img-fluid" alt="logo" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
              <ul className="navbar-nav mb-2 mb-lg-0">
                <li className="nav-item"><a className="nav-link active" href="/">Home</a></li>
                <li className="nav-item"><a className="nav-link active" href="#mission">Mission</a></li>
                <li className="nav-item"><a className="nav-link active" onClick={handleShow} style={{cursor:"pointer"}}>Chairman's Message</a></li>
                <li className="nav-item"><a className="nav-link active" href="#members">Members</a></li>
                <li className="nav-item"><a className="nav-link active" href="#manifesto">Manifesto</a></li>
                <li className="nav-item"><a className="nav-link active" href="#constitution">Constitution</a></li>
                <li className="nav-item"><a className="nav-link active" onClick={() => setShowForm(true)} style={{cursor:"pointer"}}>Join The Movement</a></li>
                <li className="nav-item"><a className="nav-link active" onClick={() => setShowPlayer(true)} style={{cursor:"pointer"}}>Official Song</a></li>
              </ul>
            </div>

            {/* Bell — sits outside the collapsible nav so it's always visible */}
            <BellDropdown onOpenElection={() => setShowElection(true)} />
          </div>
        </nav>
      </div>

      {/* Official song modal */}
      <Modal aria-labelledby="song-modal" centered show={showPlayer} onHide={() => setShowPlayer(false)}>
        <Modal.Header closeButton>
          <h2 className="font-bold">Our Official Song</h2>
        </Modal.Header>
        <Modal.Body>
          <audio style={{ maxWidth: "100%", width: "100%" }} controls loop id="offSong" src={officialSong} />
        </Modal.Body>
      </Modal>

      {/* Join form modal */}
      <Modal aria-labelledby="join-modal" centered show={showForm} onHide={() => setShowForm(false)} className="contactModal">
        <div className="closeIcon" onClick={() => setShowForm(false)}>
          <i className="fa-solid fa-xmark" />
        </div>
        <ContactForm handleCloseForm={() => setShowForm(false)} />
      </Modal>

      {/* Election results modal */}
      <ElectionResultsModal show={showElection} onClose={() => setShowElection(false)} />
    </div>
  );
}

export default Header;
